import { Redirect, useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

import { AuthContainer, VerifyOtp } from '@fhs/auth';

export default function VerifyOtpPage() {
  const { loginJwt } = useLocalSearchParams<{ loginJwt?: string }>();
  if (!loginJwt) {
    return <Redirect href="/v2/signin" />;
  }
  return (
    <>
      <Head>
        <title>Verify - Firehouse Subs</title>
      </Head>
      <AuthContainer>
        <VerifyOtp />
      </AuthContainer>
    </>
  );
}
